import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gg-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M257 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM207.5 382.8l75-75.2-77.2-77.2-24.4 24.4 53.1 52.9-26.6 26.6-77.2-77.2 77.2-77.2 11.1 11.1 24.2-24.2-35.2-35.4-125.7 125.7zM306.5 380.6l125.7-125.6-125.7-125.7-75 75 77.2 77.2 24.4-24.4-53.1-52.9 26.5-26.5 77.2 77.2-77.2 77.2-11.1-11.1-24.1 24.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/gg-circle.js
// module id = 690
// module chunks = 0